import { GiClothes } from "react-icons/gi";

export default function ClothesIcon(props: { size: number }) {
  return GiClothes({ size: props.size }) as React.ReactElement;
}
